import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppShell from "@/components/AppShell";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Members from "@/pages/Members";
import Plans from "@/pages/Plans";
import Products from "@/pages/Products";
import POS from "@/pages/POS";
import Reports from "@/pages/Reports";
import AccessLogs from "@/pages/AccessLogs";
import Notifications from "@/pages/Notifications";
import Devices from "@/pages/Devices";
import Employees from "@/pages/Employees";
import GlgAdmin from "@/pages/GlgAdmin";
import Caja from "@/pages/Caja";
import Ajustes from "@/pages/Ajustes";

const wrap = (el) => (
  <ProtectedRoute>
    <AppShell>{el}</AppShell>
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={wrap(<Dashboard />)} />
              <Route path="/members" element={wrap(<Members />)} />
              <Route path="/plans" element={wrap(<Plans />)} />
              <Route path="/products" element={wrap(<Products />)} />
              <Route path="/pos" element={wrap(<POS />)} />
              <Route path="/caja" element={wrap(<Caja />)} />
              <Route path="/ajustes" element={wrap(<Ajustes />)} />
              <Route path="/reports" element={wrap(<Reports />)} />
              <Route path="/access-logs" element={wrap(<AccessLogs />)} />
              <Route path="/notifications" element={wrap(<Notifications />)} />
              <Route path="/devices" element={wrap(<Devices />)} />
              <Route path="/employees" element={wrap(<Employees />)} />
              <Route path="/glg" element={wrap(<GlgAdmin />)} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" theme="dark" />
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
